import { webClient } from "@shared/apis";


const { REACT_APP_API_URL } = process.env
const path = REACT_APP_API_URL + "/wownet"

export default {
  getPartnerStock: (analId: string, joinDate: string) =>
    webClient.get<PartnerStock>(`${path}/partner_stock?analId=${analId}&joinDate=${joinDate}`),
  getPartnerStockComment: (itemSeq: string) =>
    webClient.get<PartnerStockCommentList>(
      `${path}/partner_stock_comment?itemSeq=${itemSeq}`,
    ),
  getPartnerMenu: (analId: string) =>
    webClient.get<PartnerMenuList>(`${path}/partner_menu?analId=${analId}`),
  getLiveInfo: () => webClient.get<LiveInfo>(`${path}/live-info`),
  getStockVod: () => webClient.get<StockVodList>(`${path}/stock_vod`),
}

export interface StockItem {
  itemSeq: string
  gubun: string
  stockCode: string
  stdStockCode: string
  stockName: string
  currentPrice: string
  isNew: "Y" | "N"
  chgType: "+" | "-"|""
  losscutPrice: string
}

// 매매 전략
export interface PartnerStock {
  isView: "Y" | "N"
  itemCount: number
  baseDatetime: string
  boardUrl: string
  stockItemList: StockItem[]
}

export interface PartnerStockComment {
  comment: string
  regdate: string
}

// 매매 전략 - 상세내용
export interface PartnerStockCommentList {
  commentCount: number
  commentList: PartnerStockComment[]
}

// 우측하단-파트너메뉴1~3

export interface PartnerMenu {
  menuName: string
  linkUrl: string
}
export interface PartnerMenuList {
  menuCount: number
  menuList: PartnerMenu[]
}

//
export interface LiveInfo {
  videoID: string
  title: string
  programName: string
  programUrl: string
  description: string
  startTime: string
  endTime: string
}

export interface StockVod {
  vodNum: string
  title: string
  imageUrl: string
  playurl: string
  regdate: string
}

export interface StockVodList {
  vodList: StockVod[]
}